module.exports = __webpack_public_path__ + "front/img/logo.34f766c6.png";